import React from "react"
import Layout from "../../components/layout"
import { withPrefix } from "gatsby"
import Image from "../../components/image"
import { AppendixWaypoint, Appendix } from "../../components/appendix"
import Hero from "../../components/hero"
import { PageColumns, Column } from "../../components/page-column"
import ReadNext from "../../components/read-next"
import MobileOnly from "../../components/mobile-only"
import Video from "../../components/video"

const PAGESLUG = "debt-dynamics"

const video = (
  <Video
    videoNative={withPrefix("/") + "video/debt-dynamics/debt-dynamics.mp4"}
    track={withPrefix("/") + "video/debt-dynamics/debt-dynamics.vtt"}
    posterImage={"spotlights/debt-dynamics/video-poster.jpg"}
  />
)

const image1 = (
  <Image
    path="spotlights/debt-dynamics/debt-dynamics-1.jpg"
    alt="Kristalina Georgieva and Janet Yellen, Secretary of the United States Treasury, take part in a conversation on Economic Recovery: Toward a Green, Resilient, and Inclusive Future during the 2021 Spring Meetings in Washington D.C."
  />
)

export default function TheGreatDivergence() {
  return (
    <Layout>
      <section className="page page--pullBottom page--margin-large">
        <Hero
          title="Debt Dynamics"
          text="Government support measures have provided an important lifeline, but the resulting rise in public debt must be carefully managed, especially in countries with limited access to low-cost financing."
          image="spotlights/debt-dynamics/hero.jpg"
          video={withPrefix("/") + "video/debt-dynamics/hero.mp4?v=1"}
        />

        <PageColumns>
          <Column type="text">
            <p className="dropcap">
              The pandemic has pushed public debt levels to new heights, with
              the total approaching 100 percent of GDP globally in 2020. But the
              ability to carry debt varies widely among countries. Many emerging
              market and developing economies face tighter financing constraints
              and rising debt vulnerabilities. Although interest rates are
              currently low, a sudden rise could lead to a sharp tightening of
              financial conditions and significant capital flow reversals.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={1} />
            <p>
              Since 2018, the IMF and the World Bank have been implementing a
              multipronged approach to address rising debt vulnerabilities in
              low-income countries and emerging market and developing economies.
              Taking into account the COVID-19 pandemic and countries’ capacity
              constraints, new initiatives were launched during the year under
              the multipronged-approach umbrella. These initiatives focused on
              enhancing debt transparency, including by improving data
              dissemination and analytical guidance for both borrowers and
              creditors, scaling up CD in crisis prevention areas, and improving
              debt analysis tools.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={3} />
            <MobileOnly>{video}</MobileOnly>
            <p>
              Substantial progress has also been made on updating IMF policies.
              A new sovereign risk and Debt Sustainability Framework for Market
              Access Countries was released in February 2021. Reforms to the
              IMF’s debt limits policy have also been introduced to provide
              low-income countries with more flexibility in managing their debt,
              along with safeguards to preserve or restore debt sustainability.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={4} />
            <p>
              The IMF has also been following the uptake of enhanced collective
              action clauses in international sovereign bonds and recently
              completed a policy paper for the G20 on gaps in the architecture
              for the resolution of sovereign debt involving private sector
              creditors.
            </p>
            <MobileOnly>{image1}</MobileOnly>
            <p>
              Jointly with the World Bank, the IMF is also supporting
              implementation of the G20 Common Framework for Debt Treatments
              beyond the DSSI: an initiative designed to facilitate timely and
              orderly debt treatment for DSSI-eligible countries, with broad
              creditor participation, including by the private sector. This is
              an important step on the road to improving the international debt
              architecture. Not only can effective operationalization of the
              common framework provide important relief to the poorest
              debt-stricken countries, but it can also set the stage for a more
              universal and possibly permanent framework for efficient sovereign
              debt resolution.
            </p>
          </Column>

          <Column type="media">
            {video}
            <div style={{ marginTop: 150 }}>{image1}</div>
          </Column>
        </PageColumns>
      </section>

      <ReadNext
        sectionID="spotlight"
        pageID="toward-a-green-inclusive-digital-future"
      />
      <Appendix page={PAGESLUG} />
    </Layout>
  )
}
